import { Link } from "react-router-dom"
import { useEffect } from "react";


function CSSAnimationLibraries() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

  return (
    <div className="text-start p-3">
        <h3 className="text-center">CSS animation libraries</h3>

        <br /><br /><br /><br />
        <ul>
            <li><a href="#Animate">Animate.css</a></li>
            <li><a href="#GreenSock">GreenSock</a></li>
        </ul>

        <p>CSS animation libraries can be a great way to add some flair and interactivity to your web pages without a lot of extra coding. Here are a few of the most popular options:</p>

        <ul className="mt-3">
            <li><b>Animate.css</b>: This is a large library of pre-made animations that you can easily add to your elements using class names. It's a great option for beginners or if you just need some simple animations. [Animate.css]</li>
            <li><b>Animista</b>: This is a website where you can browse a collection of pre-made CSS animations and download only the ones you need. It's a great way to keep your file size down. [Animista]</li>
            <li><b>Magic Effects</b>: This library offers a collection of more complex and creative animations than some of the other options. It's a good choice if you want to make your website stand out. [Search magic effects css library]</li>
        </ul>

        <p className="mt-3">These are just a few of the many CSS animation libraries available. With a little searching, you're sure to find one that meets your needs.</p>
        <p className="mt-5">Here are some additional things to keep in mind when choosing a CSS animation library:</p>

        <ul>
            <li>Ease of use: How easy is it to add the animations to your code?</li>
            <li>File size: How much will the library add to the overall size of your page?</li>
            <li>Features: What types of animations does the library offer?</li>
            <li>Browser compatibility: Does the library work in all major browsers?</li>
        </ul>
        <span id="Animate"></span>
        <br /><br /><br /><br />
        <h6>Animate.css</h6>
        <p className="mt-3">Animate.css is a popular library that provides a wide range of pre-built CSS animations  you can easily incorporate into your web pages to add pizazz and user interaction. It's known for being:</p>

        <ul>
            <li><b>Simple to use</b>: Adding animations involves just including a class name to the HTML element you want to animate.</li>
            <li><b>Beginner-friendly</b>: It's a great choice for those new to web animation or if you just need some basic animations.</li>
        </ul>


        <p className="mt-4">Here's a quick rundown on how to use Animate.css:</p>

        <ol>
            <li><b>Include the library</b>: There are a couple of ways to do this. You can download the library and reference the CSS file in your project, or you can use a CDN (Content Delivery Network) link.</li>
            <li><b>Add the class</b>:  To apply an animation to an element, add the class animate__animated along with the specific animation name you want (prefixed with animate__). For instance, to make a heading bounce, you'd use:</li>
        </ol>

        <div className="p-3 bg-dark text-light">
            <h6>HTML</h6>
            <br />
            <p>{`<`} <span className="text-warning">h1 class</span>=<span className="text-info">"animate__animated animate__bounce"</span>{` >`} This heading will bounce!{`<`}<span className="text-warning">h1</span>{`>`}</p>
        </div>

        <p className="mt-5">That's all there is to it! Animate.css offers a plethora of animation options you can explore on their website [Animate.css].</p>
        <p className="mt-5">Remember, while animations can enhance user experience, it's important to use them judiciously to avoid overwhelming your users.</p>
        <span id="GreenSock"></span>
        <br /><br />
        <hr />
        <br />
        <h6>GreenSock</h6>
        <p className="mt-5">GreenSock, specifically GSAP (GreenSock Animation Platform), is a different beast compared to Animate.css. Here's a breakdown of how they differ:</p>

        <ul className="mt-5">
            <b>Animate.css:</b>
            <li><b>Focus</b>: Pre-built CSS animations</li>
            <li><b>Pros</b>: Easy to use, beginner-friendly, large variety of animations</li>
            <li><b>Cons</b>: Limited control, animations are pre-defined, can bloat file size</li>
        </ul>

        <ul className="mt-5">
            <b>GreenSock (GSAP):</b>
            <li><b>Focus</b>: JavaScript animation library</li>
            <li><b>Pros</b>: Highly customizable, powerful, excellent performance, vast animation capabilities (CSS, SVG, Canvas, etc.)</li>
            <li><b>Cons</b>: Steeper learning curve compared to Animate.css, requires JavaScript knowledge</li>
        </ul>



        <p className="mt-4">Choosing between them:</p>
        <ul>
            <li><b>Use Animate.css if</b>: You need simple animations and prioritize ease of use.</li>
            <li><b>Use GreenSock (GSAP) if</b>: You need more control over animations, require high performance, or want to create complex animation effects.</li>
        </ul>


        <p>Here are some additional details about GreenSock:</p>

        <ul>
            <li><b>Industry Standard</b>: GSAP is a widely used and respected JavaScript library for web animation.</li>
            <li className="mt-2"><b>Flexibility</b>: It can animate various elements including CSS properties, SVG elements, Canvas elements, and more. Plugins extend its functionality for things like scroll-based animations or motion path animations.</li>
            <li className="mt-2"><b>Performance</b>: GSAP is known for its speed and efficiency, making it a good choice for complex animations.</li>
        </ul>


        {/* btn  */}
        <br />
        <br />
        <div className="text-center">
            <Link className="px-3" to='/TutorialCss/Transition'>Previous</Link>
            <Link className="px-3" to='/TutorialCss/MediaQueries'>Next</Link>
        </div>
    </div>
  )
}

export default CSSAnimationLibraries